import { render, staticRenderFns } from "./any-link-old.vue?vue&type=template&id=01139d8c&scoped=true&"
import script from "./any-link-old.vue?vue&type=script&lang=js&"
export * from "./any-link-old.vue?vue&type=script&lang=js&"
import style0 from "./any-link-old.vue?vue&type=style&index=0&id=01139d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01139d8c",
  null
  
)

export default component.exports